export default __webpack_public_path__ + "assets/images/247112acacf045e34853861ef4b284fe.svg";